angular.module('sdbgui').component 'queryconfigs',
  templateUrl: '/static/components/sdbgui-queryconfigs/sdbgui-queryconfigs.template.html'
  bindings:
    baseUrl: '@'
    headerTitle: '@'
  controller: [
    '$scope'
    '$uibModal'
    'sortingService'
    'slashDB'
    'sessionControlService'
    ($scope, $uibModal, sortingService, slashdb, sessionControlService) ->
      ctrl = this
      ctrl.sort = sortingService

      @$onInit = ->
        $scope.searchable_fields = [
          'query_id', 'desc', 'database', 'http_methods_str', 'parameters_str'
        ]
        @updateConfigList()
        .finally =>
          sessionControlService.onSessionLost =>
            ctrl.listAlert = sessionControlService.expiredMsg

          sessionControlService.onSessionRestore =>
            ctrl.updateConfigList()
        return

      @updateConfigList = ->
        url = ctrl.baseUrl + '.json'
        return slashdb.get(url, { params: guidata: '' }, false, false).then((response) ->
          configs = []
          ctrl.configsDict = response.data.querydefs
          for configId of ctrl.configsDict
            config = ctrl.configsDict[configId]
            config.http_methods_str = []
            for key of config.http_methods
              if config.http_methods[key]
                config.http_methods_str.push key
            config.http_methods_str = config.http_methods_str.join(', ')
            config.parameters_str = config.parameters.join(', ')
            configs.push config
          ctrl.createNew = response.data.create
          ctrl.listAlert = ''
          ctrl.configs = configs
          return
        ).catch (response) ->
          ctrl.listAlert = response.headers('Warning')
          ctrl.configs = []
          return
        .catch (response) ->
          ctrl.listAlert = 'Unexpected error'
          console.log(response.toString())
          ctrl.configs = []
          return


      return
  ]
